"use client";

import Link from "@/components/ui/LocaleLink";
import { writeRequestPrefill } from "@/lib/chat/request-prefill";

/**
 * The link half of `MatchCard`: it hands the page's category to `/request`
 * through the same local-storage prefill the chat uses (never the URL), so the
 * form opens with that category chosen. Without JS it is a plain link.
 */
export default function MatchLink({
  category,
  className,
  children,
}: {
  category: string;
  className: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href="/request"
      className={className}
      onClick={() => {
        if (category) writeRequestPrefill({ category, location: "", description: "" });
      }}
    >
      {children}
    </Link>
  );
}
